import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["upcoming", "past", "upcomingLink", "pastLink"]

  connect() {
    this.showUpcoming()
  }

  preventDefault(event) {
    event.preventDefault()
  }

  showUpcoming(event) {
    if (event) event.preventDefault()
    
    this.upcomingTarget.classList.remove("hidden")
    this.pastTarget.classList.add("hidden")
    
    this.upcomingLinkTarget.classList.add("underline")
    this.pastLinkTarget.classList.remove("underline")
  }

  showPast(event) {
    if (event) event.preventDefault()
    
    this.pastTarget.classList.remove("hidden")
    this.upcomingTarget.classList.add("hidden")
    
    this.pastLinkTarget.classList.add("underline")
    this.upcomingLinkTarget.classList.remove("underline")
  }
}

